/* eslint-disable no-unused-vars */
import { useTheme } from '@emotion/react';
import {
  Timeline,
  TimelineContent,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
} from '@mui/lab';
import {
  Avatar,
  Box,
  Card,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import buy from 'assets/dummy/buy.jpg';
import { ReactComponent as Eye } from 'assets/icons/eye.svg';
import React, { useEffect, useState } from 'react';
import { themeGray } from 'theme/color';
import {
  fontsize10,
  fontsize16,
  poppins300,
  poppins400,
  poppins500,
} from 'theme/common.style';
// import { ReactComponent as Line } from "assets/icons/line.svg";
import { getApiCall, getOwnerCardActivity } from 'api/apiService';
import { getUserCardActivity } from 'constant/app.config';
import { isUndefined } from 'lodash';
import { useParams } from 'react-router-dom';
import {
  activityCont,
  activityContCard,
  activityContSmall,
  circleCont,
  displayFlex,
  displayFlexRow,
  imageCont,
  userDetCont,
} from './LiveActivityFeed.style';
import moment from 'moment';

const Line = () => {
  return (
    <div
      style={{
        borderLeft: '1.4px dashed #D9D9D9', // Adjust the width and color as needed
        minHeight: '1px',
        height: '100%',
      }}
    ></div>
  );
};

function LiveActivityFeed(props) {
  const {
    agentindividual,
    activitywidth,
    proid,
    rowData,
    ownercardprop,
    buyerId,
    expanded,
    expand,
    marketShow,
    removeBorder,
    buyercard,
    isPipelineManagement,
  } = props;

  const local = [1, 2, 3, 4, 5];
  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);
  const Activityid = userDetail?.userId;
  const [mount, setMount] = useState(true);
  const [activityData, setActivitydata] = useState([]);
  const [activityDataErrMsg, setActivityDataErrMsg] = useState({});
  const params = useParams();
  const ownerId = rowData?.user?.userId;
  useEffect(() => {
    if (!proid) return;
    const inputData = {
      propertyId: params?.dashboardId,
    };
    var mounted = true;

    if (ownercardprop) {
      getOwnerCardActivity(proid, ownerId, marketShow).then((res) => {
        setActivitydata(res?.activities?.reverse());
        setActivityDataErrMsg(res);
      });
    } else {
      const id = marketShow ? 0 : proid;
      if (buyerId) {
        getApiCall(getUserCardActivity + `/${id}/${buyerId}/Default`).then(
          (resp) => {
            if (mounted) {
              if (resp?.data?.status === 1) {
                setActivitydata(resp?.data?.activities?.reverse());
                setActivityDataErrMsg(resp);
                setMount(false);
              }
            }
          }
        );
      }
    }
    return () => (mounted = false);
  }, [proid]);

  // useEffect(() => {
  //   getData();
  // }, [proid]);
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const isSm = useMediaQuery(theme.breakpoints.down(430));
  const matches1500 = useMediaQuery(theme.breakpoints.down(1500));
  const matches1700 = useMediaQuery(theme.breakpoints.down(1700));
  const matches370 = useMediaQuery(theme.breakpoints.down(370));
  const matches870 = useMediaQuery(theme.breakpoints.down(870));
  const widthSize = expanded === undefined;

  return (
    <Card
      variant="outlined"
      sx={
        isSm
          ? activityContSmall
          : activitywidth && !isSm
          ? activityContCard
          : activityCont
      }
      style={{
        width: buyercard && matchessm ? '96%' : '100%',
        marginBottom: '15px',
        marginLeft: matchessm ? '0px' : '13px',
        marginTop: '0',
        border: removeBorder && 'none',
      }}
    >
      {!activitywidth && (
        <Stack
          sx={{
            width: '100%',
            height: '38px',

            background: 'rgba(188, 187, 188, 0.1)',
            border: '0.5px solid #E4E4E4',
            borderRadius: ' 5px',
          }}
          alignItems={'self-start'}
          justifyContent={'center'}
        >
          <Typography
            sx={{
              textAlign: 'center',
              ...poppins500,
              fontSize: '14px',
              color: '#26344E',
              paddingLeft: '10px',
            }}
          >
            Live Activity Feed
          </Typography>
        </Stack>
      )}
      {!agentindividual ? (
        activityDataErrMsg?.status == 1 ? (
          <Typography
            sx={[
              displayFlex,
              {
                marginTop: '20px',
                marginLeft: isPipelineManagement ? '0px' : '-30px',
              },
            ]}
          >
            {activityData
              ?.slice()
              .sort((a, b) => {
                if (a.activityCatogory === 'Today') {
                  return -1;
                } else if (b.activityCatogory === 'Today') {
                  return 1;
                } else if (a.activityCatogory === 'Yesterday') {
                  return -1;
                } else if (b.activityCatogory === 'Yesterday') {
                  return 1;
                } else {
                  return (
                    new Date(b.activityCatogory) - new Date(a.activityCatogory)
                  );
                }
              })
              .map((item, index, arr) => {
                const isNewCategoryNew =
                  item.activityCatogory !== arr[index + 1]?.activityCatogory;
                const isNewCategory =
                  index === 0 ||
                  item.activityCatogory !== arr[index - 1].activityCatogory;
                let formattedDate;
                if (
                  index.activityCatogory == 'Today' ||
                  index.activityCatogory == 'Tomorrow' ||
                  index.activityCatogory == 'Yesterday'
                ) {
                  formattedDate = index.activityCatogory;
                } else {
                  formattedDate = moment(index.activityCatogory).format(
                    'DD-MM-YYYY'
                  );
                }
                return (
                  <React.Fragment key={index.activityId}>
                    <Grid>
                      {isNewCategory && (
                        <TimelineItem
                          sx={
                            isPipelineManagement && {
                              '&:before': {
                                flex: 0,
                                padding: 0,
                              },
                            }
                          }
                          // sx={{ marginBottom: "-19px"}}
                        >
                          <TimelineSeparator xs={0.5}>
                            <Typography sx={circleCont}>
                              <Eye width={12} height={12} />
                            </Typography>
                            {index < arr?.length > 0 ? (
                              <>
                                <div
                                  style={{
                                    borderLeft: '1.4px dashed #D9D9D9',
                                    minHeight: '100%',
                                  }}
                                ></div>
                              </>
                            ) : (
                              ''
                            )}
                          </TimelineSeparator>
                          <Grid
                            xs={widthSize ? 11.4 : 11}
                            sx={{ marginTop: '5px' }}
                            item
                          >
                            <Box>
                              <Typography
                                xs={widthSize ? 11.4 : 11}
                                sx={{
                                  ...poppins300,
                                  fontSize: '12px',
                                  color: '#000000',
                                  padding: '10px',
                                }}
                              >
                                {/* {item.activityCatogory} */}
                                {formattedDate}
                              </Typography>
                            </Box>
                          </Grid>
                        </TimelineItem>
                      )}
                      <TimelineItem
                        sx={
                          isPipelineManagement && {
                            '&:before': {
                              flex: 0,
                              padding: 0,
                            },
                          }
                        }
                        // sx={{ marginBottom: "-29px"}}
                      >
                        {/* <Grid
                      // item
                      xs={0.5}
                      // sx={[
                      //   imageCont,
                      //   {
                      //     display: "flex",
                      //     flexDirection: "column",
                      //     marginTop: "5px",
                      //   },
                      // ]}
                      // spacing={2}
                    > */}
                        {/* {index !== activityData.length && (
                        <>
                          <Line height={13} width={2} />
                        </>
                      )} */}
                        <TimelineSeparator
                          xs={0.5}
                          style={{ position: 'relative', top: '20px' }}
                        >
                          <Typography sx={circleCont}>
                            <Eye width={12} height={12} />
                          </Typography>
                          {arr?.length - 1 > index && !isNewCategoryNew && (
                            <>
                              <div
                                style={{
                                  borderLeft: '1.4px dashed #D9D9D9',
                                  minHeight: '100%',
                                }}
                              ></div>
                            </>
                          )}
                        </TimelineSeparator>
                        {/* </Grid> */}

                        <Grid
                          xs={widthSize ? 11.4 : 11}
                          item
                          sx={{
                            marginLeft: '10px',
                            borderRadius: '6px',
                            boxShadow: 'rgba(0, 0, 0, 0.15)',
                            ...(isPipelineManagement && {
                              flex: 1,
                              minWidth: 0,
                            }),
                            // width: "269px",
                            // height: "62px",
                          }}
                        >
                          <Box
                            sx={{
                              borderRadius: '5px',
                              border: '1px solid #D9D9D9;',
                            }}
                          >
                            <Typography
                              sx={userDetCont}
                              style={{
                                justifyContent: 'start',
                                gap: '10px',
                                position: 'relative',
                              }}
                            >
                              <Typography sx={imageCont}>
                                {item.profileImage == '' ||
                                item.profileImage == null ? (
                                  <Avatar sx={{ backgroundColor: '#666666' }}>
                                    {item?.userName?.charAt(0)?.toUpperCase()}
                                    {item?.userSurName
                                      ?.charAt(0)
                                      ?.toUpperCase()}
                                  </Avatar>
                                ) : (
                                  <Avatar
                                    alt="Remy Sharp"
                                    src={item.profileImage}
                                  />
                                )}
                                &nbsp;
                              </Typography>

                              <Typography
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}
                              >
                                <Typography sx={displayFlex}>
                                  <Typography
                                    sx={{
                                      ...poppins500,
                                      fontSize: '16px',
                                      color: '#112347',
                                      width: widthSize ? '100%' : '180px',
                                      wordBreak: 'break-word',
                                      whiteSpace:
                                        ownercardprop &&
                                        matches1700 &&
                                        widthSize
                                          ? ''
                                          : 'nowrap',
                                    }}
                                  >
                                    {item.activityName}
                                  </Typography>
                                </Typography>
                                <Typography
                                  sx={{ ...poppins400, fontSize: '10px' }}
                                  style={{
                                    display: 'flex',
                                    color: 'rgba(102, 102, 102, 1)',
                                    width: widthSize
                                      ? '100%'
                                      : !expanded
                                      ? '160px'
                                      : '160px',
                                    marginBottom: '10px',
                                  }}
                                >
                                  {item.activity}
                                </Typography>
                              </Typography>
                              <Typography
                                sx={{ ...poppins400, fontSize: '10px' }}
                                style={{
                                  display: 'flex',
                                  alignItems: 'end',
                                  color: 'rgba(196, 196, 196, 1)',
                                  justifyContent: 'end',
                                  position: 'absolute',
                                  bottom: '5px',
                                  right: '5px',
                                }}
                              >
                                {item.activityTime}
                              </Typography>
                            </Typography>
                          </Box>
                        </Grid>
                      </TimelineItem>
                    </Grid>
                  </React.Fragment>
                );
              })}
          </Typography>
        ) : (
          <Typography
            sx={{
              fontWeight: 400,
              fontFamily: 'poppins',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '25px',
              color: '#666666',
            }}
          >
            {activityDataErrMsg?.message}
          </Typography>
        )
      ) : activityDataErrMsg?.status == 200 ? (
        <Typography sx={displayFlex}>
          <div
            style={{
              overflowY: 'scroll',
              '-webkit-scrollbar': {
                display: 'none',
              },
              '-ms-overflow-style': 'none' /* IE and Edge */,
              'scrollbar-width': 'none',
              maxHeight: '560px',
              marginTop: '10px',
              marginLeft: buyercard && matches370 && '-15px',
            }}
          >
            <Grid sx={[displayFlexRow, {}]}>
              <Timeline
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  padding: 0,
                }}
              >
                {activityData
                  ?.slice()
                  .sort((a, b) => {
                    if (a.activityCatogory === 'Today') {
                      return -1;
                    } else if (b.activityCatogory === 'Today') {
                      return 1;
                    } else if (a.activityCatogory === 'Yesterday') {
                      return -1;
                    } else if (b.activityCatogory === 'Yesterday') {
                      return 1;
                    } else {
                      return (
                        new Date(b.activityCatogory) -
                        new Date(a.activityCatogory)
                      );
                    }
                  })
                  .map((index, i, arr) => {
                    // if (!renderedCategories.includes(index.activityCatogory)) {
                    //   renderedCategories.push(index.activityCatogory);
                    const isNewCategory =
                      i === 0 ||
                      index.activityCatogory !== arr[i - 1].activityCatogory;
                    const isNewCategoryNew =
                      index.activityCatogory !== arr[i + 1]?.activityCatogory;

                    let formattedDate;
                    if (
                      index.activityCatogory == 'Today' ||
                      index.activityCatogory == 'Tomorrow' ||
                      index.activityCatogory == 'Yesterday'
                    ) {
                      formattedDate = index.activityCatogory;
                    } else {
                      formattedDate = moment(index.activityCatogory).format(
                        'DD-MM-YYYY'
                      );
                    }
                    return (
                      <React.Fragment key={index.activityId}>
                        {isNewCategory && (
                          <>
                            <TimelineItem
                              sx={{
                                paddingLeft: '10px',
                                marginBottom: '-15px',
                                marginTop: '4px',
                              }}
                            >
                              <TimelineSeparator sx={{ padding: '0px' }}>
                                <Typography sx={circleCont}>
                                  <Eye width={12} height={12} />
                                </Typography>
                                {/* {index.activityId !== properties?.length &&
                    index.activityId > 0 ? ( */}
                                <>
                                  <div
                                    style={{
                                      borderLeft: '1.4px dashed #D9D9D9', // Adjust the width and color as needed
                                      minHeight: '1px',
                                      height: '100%',
                                    }}
                                  ></div>
                                </>
                              </TimelineSeparator>
                              <Grid
                                xs={widthSize ? 11.4 : 11}
                                item
                                sx={{ marginTop: '5px' }}
                              >
                                <Box>
                                  <Typography
                                    xs={widthSize ? 11.4 : 11}
                                    sx={{
                                      // display: "flex",
                                      // alignItems: "center",
                                      // justifyContent: "center",
                                      ...poppins300,
                                      fontSize: '12px',
                                      color: '#000000',
                                      padding: '10px',
                                    }}
                                  >
                                    {/* {index.activityCatogory} */}
                                    {formattedDate}
                                  </Typography>
                                </Box>
                              </Grid>
                            </TimelineItem>
                          </>
                        )}

                        <TimelineItem
                          key={index.activityId}
                          sx={{ paddingLeft: '10px' }}
                        >
                          <TimelineSeparator
                            xs={0.5}
                            style={{ position: 'relative', top: '20px' }}
                          >
                            <Typography sx={circleCont}>
                              <Eye width={12} height={12} />
                            </Typography>
                            {arr?.length - 1 > i && !isNewCategoryNew && (
                              <>
                                <div
                                  style={{
                                    borderLeft: '1.4px dashed #D9D9D9', // Adjust the width and color as needed
                                    minHeight: '1px',
                                    height: '100%',
                                  }}
                                ></div>
                              </>
                            )}
                          </TimelineSeparator>

                          <TimelineContent
                            sx={{
                              // marginTop: "-25px",
                              padding: '0px',
                              paddingLeft:
                                buyercard && matches370 ? '5px' : '10px',
                              marginBottom: '10px',
                            }}
                          >
                            <Card
                              sx={{
                                border: '1px solid #D9D9D9',
                                boxShadow: removeBorder
                                  ? '0px 1px 6px rgba(0, 0, 0, 0.15)'
                                  : 'none',
                                padding: removeBorder
                                  ? '20px 18px'
                                  : '10px 10px',
                                marginBottom: removeBorder && '7px',
                                mr: activitywidth
                                  ? '5px'
                                  : buyercard && matches370
                                  ? '1px'
                                  : '',
                              }}
                            >
                              <Stack
                                sx={imageCont}
                                gap={buyercard && matches370 ? 1 : 2}
                              >
                                <Typography>
                                  {index?.profileImage == '' ||
                                  index?.profileImage == null ? (
                                    <Avatar
                                      sx={{
                                        height: '36.5px',
                                        width: '36.5px',
                                        fontFamily: 'poppins',
                                        backgroundColor: '#666666',
                                      }}
                                    >
                                      {index?.userName
                                        ?.charAt(0)
                                        ?.toUpperCase()}
                                      {index?.userSurName
                                        ?.charAt(0)
                                        ?.toUpperCase()}
                                    </Avatar>
                                  ) : (
                                    <Avatar
                                      alt="Remy Sharp"
                                      src={index?.profileImage}
                                      sx={{ height: '36.5px', width: '36.5px' }}
                                    />
                                  )}
                                </Typography>
                                <Stack sx={{ width: '100%' }}>
                                  <Typography
                                    sx={{
                                      ...poppins500,
                                      ...fontsize16,
                                      color: '#112347',
                                      wordBreak: 'break-word',
                                    }}
                                  >
                                    {index?.activityName}
                                  </Typography>
                                  <Stack sx={{ width: '100%' }}>
                                    <Typography
                                      sx={{
                                        ...poppins400,
                                        ...fontsize10,
                                        margin: '0px',
                                        // position: "relative",
                                        // whiteSpace: "nowrap",
                                        width: activitywidth ? '100%' : '170px',
                                        display: activitywidth && 'flex',
                                        flexDirection:
                                          activitywidth &&
                                          (matches1500 ? 'column' : 'row'),
                                        alignItems:
                                          activitywidth &&
                                          (matches1500
                                            ? 'flex-start'
                                            : 'center'),
                                        position: activitywidth && 'relative',
                                        wordBreak: 'break-word',
                                      }}
                                      style={{
                                        color: themeGray,
                                      }}
                                    >
                                      {index?.activity}
                                      <span
                                        style={{
                                          ...poppins400,
                                          ...fontsize10,
                                          color: '#C4C4C4',
                                          position:
                                            activitywidth && matches1500
                                              ? 'static'
                                              : 'absolute',
                                          right: '0px',
                                          margin:
                                            activitywidth && matches1500
                                              ? '0px'
                                              : '5px',
                                          marginTop:
                                            activitywidth &&
                                            (matches1500 ? '5px' : '0px'),
                                          alignSelf:
                                            activitywidth &&
                                            (matches1500
                                              ? 'flex-end'
                                              : 'center'),
                                        }}
                                      >
                                        {index?.activityTime}
                                      </span>
                                    </Typography>
                                  </Stack>
                                </Stack>
                              </Stack>
                            </Card>
                          </TimelineContent>
                        </TimelineItem>
                      </React.Fragment>
                    );
                  })}
              </Timeline>
            </Grid>
          </div>
        </Typography>
      ) : (
        <Typography
          sx={{
            fontWeight: 400,
            fontFamily: 'poppins',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '25px',
            color: '#666666',
          }}
        >
          Activity not found
        </Typography>
      )}

      {!agentindividual &&
      !activityData?.length &&
      activityData?.status === -1 ? (
        <>
          <Typography
            sx={{
              display: 'flex',
              fontFamily: 'poppins',
              width: '100%',
              justifyContent: 'center',
              padding: '15px 0px',
              fontWeight: 400,
            }}
          >
            No activities found
          </Typography>
        </>
      ) : null}
    </Card>
  );
}

// LiveActivityFeed.propTypes = {};

export default LiveActivityFeed;
